import { Restaurant } from './restaurant';
import { RestaurantKey } from './restaurant-key';

export class Restaurants {
  constructor(private readonly list: Restaurant[]) {}

  exists(): boolean {
    return this.list.length >= 1;
  }

  eq(other: Restaurants): boolean {
    if (this.list.length !== other.list.length) {
      return false;
    }
    return this.list.every((v, i) => v.eq(other.list[i]));
  }

  getList(): Restaurant[] {
    return this.list;
  }

  getCount(): number {
    return this.list.length;
  }

  findByKey(key: RestaurantKey | null): Restaurant | null {
    if (key === null) {
      return null;
    }

    const found = this.list.find(restaurant => {
      return restaurant.key.eq(key);
    });

    if (!found) {
      return null;
    }

    return found;
  }

  getFirst(): Restaurant | null {
    if (!this.exists()) {
      return null;
    }

    return this.list[0];
  }

  getNext(restaurant: Restaurant): Restaurant | null {
    const currentIndex = this.getIndexByKey(restaurant.key);
    return this.findByIndex(currentIndex + 1);
  }

  getPrev(restaurant: Restaurant): Restaurant | null {
    const currentIndex = this.getIndexByKey(restaurant.key);
    return this.findByIndex(currentIndex - 1);
  }

  getIndexByKey(key: RestaurantKey | null): number {
    if (key === null) {
      return -1;
    }

    return this.list.findIndex(restaurant => {
      return restaurant.key.eq(key);
    });
  }

  private findByIndex(index: number): Restaurant | null {
    const restaurant = this.list[index];
    if (!restaurant) {
      return null;
    }

    return restaurant;
  }
}
